export enum DelimiterType {
	Comma = 1,
	Semicolon = 2
}